import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { SectionAnalyticsContextProvider } from '@invitae/nucleobase-analytics';
import BaseSection from './BaseSection.esm.js';

var BaseSectionWithAnalyticsContext = function (_a) {
    var sectionName = _a.sectionName, children = _a.children, rest = __rest(_a, ["sectionName", "children"]);
    return (React.createElement(SectionAnalyticsContextProvider, { value: { section: sectionName } },
        React.createElement(BaseSection, __assign({}, rest), children)));
};

export { BaseSectionWithAnalyticsContext as default };
//# sourceMappingURL=BaseSectionWithAnalyticsContext.esm.js.map
